import React from 'react';
import { FadeLoader } from 'react-spinners';
import styles from './styles';
import { colors } from '../../assets/styles';

export const LoadingSpinner: React.FC = () => {
  return (
    <div className={styles.displayFlexWrapper}>
      <FadeLoader color={colors.darkBlueBackground} />
    </div>
  );
};
